/**
 * Where the app sends people, in one place.
 *
 * The post-login destination was written out four times — two login pages and
 * two guards — plus twice more in the shell. Moving the landing screen meant
 * finding all six, and the E2E only ever caught the one it happened to assert.
 * A constant makes that a single edit.
 */

/** The expert's landing screen: the two cards. */
export const HOME_ROUTE = '/home';

/** The admin console's landing screen. */
export const ADMIN_HOME_ROUTE = '/admin/home';

/** Where a signed-in user belongs, by role. */
export function homeRouteFor(role: string | undefined): string {
  return role === 'admin' ? ADMIN_HOME_ROUTE : HOME_ROUTE;
}

/** The one form that opens a project. */
export const PROJECT_CREATE_ROUTE = '/projects/new';

export interface ProjectCreatePrefill {
  readonly name?: string;
  readonly domainId?: number | null;
  readonly description?: string | null;
}

/**
 * The create form, with boxes already filled.
 *
 * The command bar sends a spoken "start a new project about warehouse routing"
 * here rather than growing a second copy of the form. Written as a function so
 * the two sides of that contract — who writes the query string and who reads
 * it — cannot drift apart on a parameter name.
 */
export function projectCreateRoute(prefill?: ProjectCreatePrefill): string {
  const params = new URLSearchParams();
  if (prefill?.name) params.set('name', prefill.name);
  if (prefill?.domainId != null) params.set('domain', String(prefill.domainId));
  if (prefill?.description) params.set('description', prefill.description);
  const query = params.toString();
  return query.length > 0 ? `${PROJECT_CREATE_ROUTE}?${query}` : PROJECT_CREATE_ROUTE;
}
